import React from 'react'
import { graphql } from 'gatsby'
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"

const ServiceDifference = ({title, subtitle, richContent}) => {
  return (
    <section id='our-different' className="service-difference">
      <div className='service-difference__inner'>
        <div className="service-difference__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="service-difference__left">
            {title && <h2>{parse(title)}</h2>}
          </div>

          <div className="service-difference__right">
            {subtitle && <StructuredText as="h3" data={subtitle} />}
            {richContent && <StructuredText data={richContent} />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceDifference

export const query = graphql`
fragment ServiceDifferenceProps on DatoCmsServiceDifference {
   ... on DatoCmsServiceDifference {
    id
    title
    subtitle {
      value
    }
    richContent {
      value
    }
  }
}
`;